"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { BlogSwitcher as TerraBlogSwitcher } from "../terra/component/BlogSwitcher/BlogSwitcher";
import { useRouter } from "next/navigation";
import { normalToMachineTheme } from "@/lib/utils";
const FormatBlogSwitcher = data => {
  const $ = _c(19);
  const [selection, setSelection] = useState("");
  const router = useRouter();
  let t0;
  if ($[0] !== data.value) {
    t0 = data?.value || {};
    $[0] = data.value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const blogSwitcherData = t0;
  let t1;
  if ($[2] !== blogSwitcherData.dropdownOptionsCollection?.items) {
    t1 = blogSwitcherData.dropdownOptionsCollection?.items ?? [];
    $[2] = blogSwitcherData.dropdownOptionsCollection?.items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = t1.map(_temp);
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const dropdownItems = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => {
      setSelection(value);
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleSelectionChange = t3;
  let t4;
  if ($[7] !== router) {
    t4 = url => {
      if (url.startsWith("/")) {
        router.push(url);
      } else {
        window.open(url, "_blank");
      }
    };
    $[7] = router;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleNavigate = t4;
  const t5 = blogSwitcherData.header;
  const t6 = blogSwitcherData.dropdownLabel;
  let t7;
  if ($[9] !== blogSwitcherData.theme) {
    t7 = normalToMachineTheme(blogSwitcherData.theme);
    $[9] = blogSwitcherData.theme;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = data?.headerElement;
  let t9;
  if ($[11] !== blogSwitcherData.dropdownLabel || $[12] !== blogSwitcherData.header || $[13] !== dropdownItems || $[14] !== handleNavigate || $[15] !== selection || $[16] !== t7 || $[17] !== t8) {
    t9 = <div className="blog-switcher-section"><TerraBlogSwitcher header={t5} dropdownTitle={t6} dropdownOptions={dropdownItems} selection={selection} setSelection={handleSelectionChange} presetTheme={t7} onNavigate={handleNavigate} isWrapped={true} headerElement={t8} /></div>;
    $[11] = blogSwitcherData.dropdownLabel;
    $[12] = blogSwitcherData.header;
    $[13] = dropdownItems;
    $[14] = handleNavigate;
    $[15] = selection;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default FormatBlogSwitcher;
function _temp(item) {
  return {
    label: item?.textLabel,
    url: item?.url
  };
}